export default __webpack_public_path__ + "static/cardano-ada-logo-d9b90224323ccff57026de3446f6fbb3.png";